// extracted by mini-css-extract-plugin
module.exports = {"ad":"ad-10SjbhOv","box":"box-3iUt-2iF","footer":"footer-18vU7IoG"};